var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWeb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 48.5,
    y: 7.5,
    width: 41,
    height: 41,
    rx: 3.5,
    transform: "rotate(90 48.5 7.5)",
    stroke: "#2C666E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 36L41.2929 28.7071C41.6834 28.3166 41.6834 27.6834 41.2929 27.2929L34 20",
    stroke: "#2C666E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 36L14.7071 28.7071C14.3166 28.3166 14.3166 27.6834 14.7071 27.2929L22 20",
    stroke: "#2C666E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31 19L25 38",
    stroke: "#2C666E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeb);
export default __webpack_public_path__ + "static/media/web.b47170406dc9e7d0ab0010b89c9a2bfc.svg";
export { ForwardRef as ReactComponent };